<script lang="ts">
  import ButtonInputGroup from "./ButtonInputGroup.svelte";

  export let header: string;
  export let selectValue: (vintage: string) => void;
  export let selectedValue: string | number;
  export let values: string[] = [];
  export let dataTestId = null;

</script>

<div class="fizz-card fizz-bordered">
  <div class="fizz-surface-brand fizz-inset-square-16">
    <p class="fizz-text-strong fizz-text-inverse">{header}</p>
  </div>
  <div class="fizz-inset-square-24">
    <ButtonInputGroup {values} {selectValue} {selectedValue} {dataTestId} />
  </div>
</div>
